'use strict';

function getUrlParamObject(urlParams) {
    if (!urlParams) return {};

    var paramArray = urlParams.split(new RegExp('[?&]'));
    var paramObject = {};

    paramArray.forEach(function (paramData) {
        if (paramData) {
            var paramDataArray = paramData.split('=');

            if (paramDataArray && paramDataArray.length === 2) paramObject[paramDataArray[0]] = paramDataArray[1];
        }
    });

    return paramObject;
}

function removeParamFromURL(url, name) {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
        return url;
    }
    var hash;
    var params;
    var domain = url.split('?')[0];
    var paramUrl = url.split('?')[1];
    var newParams = [];
    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
        hash = paramUrl.split('#')[1] || '';
        paramUrl = paramUrl.split('#')[0];
    }
    params = paramUrl.split('&');
    for (var i = 0; i < params.length; i++) {
        // put back param to newParams array if it is not the one to be removed
        if (params[i].split('=')[0] !== name) {
            newParams.push(params[i]);
        }
    }
    return domain + (newParams.length ? '?' : '') + newParams.join('&') + (hash ? '#' + hash : '');
}

module.exports = function() {
    var url = window.location.href;
    var params = getUrlParamObject(url);

    var $csrfModal = $('#csrfErrorModal');
    if (params && Object.hasOwnProperty.call(params, 'csrfError') && params.csrfError && $csrfModal.length > 0) {
        $csrfModal.modal('show');

        var urlWithOutCsrfError = removeParamFromURL(url, 'csrfError');
        window.history.replaceState(history.state, document.title, urlWithOutCsrfError);
    }
};